/**
 * Created by mark on 23/01/2018.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import CurriculumService from '../../../../services/curriculums-services.js';
import ContentService from '../../../../services/content-service.js';
import ModuleService from '../../../../services/screens-service.js';
import ModulesStore from '../../../../store/screen-store.js';
import ContentStore from '../../../../store/content-store.js';
import VocabObject from '../../../content-target-vocab.js';
import Translation from '../../../../store/internationalization-store.js';
import { Button , Panel , Breadcrumb , Col  , Row  } from 'react-bootstrap';
import Correct from '../../../inputs/tickbox.js';
import NumberPicker from 'semantic-ui-react-numberpicker';
import AssignmentServices from '../../../../services/assignment-services.js';

const allOptions = [
    { value: 4 , label:  <FormattedMessage id={ 'ui-117' } defaultMessage={ 'Listening' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 10 , label: <FormattedMessage id={ 'ui-119' } defaultMessage={ 'Reading' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 1 , label: <FormattedMessage id={ 'ui-118' } defaultMessage={ 'Speaking' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/>},
    { value: 7 , label: <FormattedMessage id={ 'ui-120' } defaultMessage={ 'Writing' }/> , noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> }]

const coreOptions = [
    { value: 4 ,  label: <FormattedMessage id={ 'ui-117' } defaultMessage={ 'Listening' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 10 , label: <FormattedMessage id={ 'ui-119' } defaultMessage={ 'Reading' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/> },
    { value: 7 ,  label: <FormattedMessage id={ 'ui-120' } defaultMessage={ 'Writing' }/>, noResultsText: <FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found Default" }/>  }]


class VocabularySettings extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        this.props.data.games = this.props.data.games || this.availableGames().map(function(game){
                return game.value
            });
        this.numberPickerValue =  this.totalVocab = Number((this.props.data.vocabularyTotal || 0 ));
        this.state ={numberPickerValue:this.totalVocab}

    }

    availableGames(){
        if(!this.props.data.language.hasSpeaking) return coreOptions;
        return allOptions;
    }

    updateDatabase(){

        console.log([this.props.data.homeworkID , this.props.data.games , this.numberPickerValue])
        return AssignmentServices.setVocabularyGames(this.props.data.homeworkID , this.props.data.games , this.numberPickerValue);
    }

    updateNumberPicker(incroment) {

        var number = this.state.numberPickerValue;
            number = number + incroment;

        number = number <=5 ? 5 : number;
        number = number >=this.totalVocab ? this.totalVocab : number;

        this.numberPickerValue = number;
        this.updateDatabase().then(function(){
            this.setState({numberPickerValue:number});
        }.bind(this));

    }

    isSelected(game){
        return this.props.data.games.indexOf(game.value) > -1;
    }

    onSelect(item){

        if(this.isSelected(item))
        {
            for(var index = 0 ; index < this.props.data.games.length; index++)
            {
                if(this.props.data.games[index] == item.value){
                    this.props.data.games.splice(index , index + 1)
                }
            }
        }
        else
        {
            this.props.data.games.push(item.value);
        }

        this.updateDatabase().then(function(){
            this.setState({updated:true})
        }.bind(this));

    }

    render(){

        let games = this.availableGames().map(function(game){

            return <Col md={12/this.availableGames().length}>
                <div className="b-1 m-b-10" onClick={this.onSelect.bind(this , game)} >

                    <div  style={{width:'100%' , textAlign:'left'}} className="p-10 vert-center">
                        <h5  style={{margin:0}}> {game.label}</h5>
                    </div>
                    <div  style={{width:50}} className="p-10 vert-center">
                        <Correct selected={this.isSelected(game)}  />
                    </div>
                </div>
            </Col>
        }.bind(this));

        let msg = this.totalVocab == this.state.numberPickerValue ?  <FormattedMessage id={ 'ui-000' } defaultMessage={ 'All' }/> : this.state.numberPickerValue;

        return <div>
                    <Row>
                        <Col md="12">
                            <h5>
                                <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Title for selecting vocab' }/>
                            </h5>
                        </Col>
                    </Row>
                    <Row className="p-t-10" >
                        <Col md="1">
                            <Button block onClick={this.updateNumberPicker.bind(this , -1)}> - </Button>
                        </Col>
                        <Col md="10" className="p-0">
                            <div style={{padding:'6px'}} className="b-1">
                                <center>{msg}</center>
                            </div>
                        </Col>
                        <Col md="1">
                            <Button block onClick={this.updateNumberPicker.bind(this , 1)}> + </Button>
                        </Col>
                    </Row>
                    <Row className="p-t-20">
                        <Col md="12">
                            <h5>
                                <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Select You Tests' }/>
                            </h5>
                        </Col>
                    </Row>
                    <Row className="p-t-10" >{games}</Row>
                </div>;


    }

}

export default {
    name: <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Settings' }/>,
    title:null,
    removePadding:true,
    navigationTop:true,
    onSubmit: function (done){

        AssignmentServices.setVocabularyGames(this.props.data.homeworkID , this.props.data.games , this.numberPickerValue).then(function(){
            done();
        }.bind(this));

    },
    component: VocabularySettings
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/vocabulary-builder/vocabulary-settings.js